var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSlice } from '@reduxjs/toolkit';
import { name } from './constants';
var initialState = {
    isCookiesConsentHintEnabled: false,
};
var hints = createSlice({
    name: name,
    initialState: initialState,
    reducers: {
        changeHintState: function (state, _a) {
            var payload = _a.payload;
            return __assign(__assign({}, state), payload);
        },
    },
});
export { hints };
export var changeHintState = hints.actions.changeHintState;
